import {
  GET_MUNICIPALITY_LIST_START,
  GET_MUNICIPALITY_LIST,
  GET_MUNICIPALITY_LIST_ERROR,
  GET_MUNICIPALITY_LIST_BY_PLACE_START,
  GET_MUNICIPALITY_LIST_BY_PLACE,
  GET_MUNICIPALITY_LIST_BY_PLACE_ERROR,
  ADD_MUNICIPALITY,
  ADD_MUNICIPALITY_START,
  ADD_MUNICIPALITY_ERROR,
  UPDATE_MUNICIPALITY,
  UPDATE_MUNICIPALITY_START,
  UPDATE_MUNICIPALITY_ERROR,
  GET_MUNICIPALITY_LIST_PAGEABLE,
  GET_MUNICIPALITY_LIST_PAGEABLE_START,
  GET_MUNICIPALITY_LIST_PAGEABLE_ERROR,
  GET_MUNICIPALITY_FILTER_LIST,
  GET_MUNICIPALITY_FILTER_LIST_ERROR,
  GET_MUNICIPALITY_FILTER_LIST_START,
  CLEAR_MUNICIPALITY_LIST,
} from '../actions/types';
import { numberOfItemsPerPage } from '../constants/globals';

const initialState = {
  municipalityList: [],
  municipality: {},
  loading: false,
  error: undefined,
  totalElements: '',
};

const clearList = (state) => {
  return {
    ...state,
    municipalityList: [],
  };
};

const findAllMunicipality = (state, action) => {
  return {
    ...state,
    loading: false,
    municipalityList: action.payload,
    error: undefined,
  };
};

const findAllMunicipalityStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findAllMunicipalityError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllMunicipalityByPlace = (state, action) => {
  return {
    ...state,
    loading: false,
    municipalityList: action.payload,
    error: undefined,
  };
};

const findAllMunicipalityByPlaceStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findAllMunicipalityByPlaceError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllMunicipalityPageable = (state, action) => {
  return {
    ...state,
    loading: false,
    municipalityList: action.payload[0],
    numberOfPages: action.payload[1],
    totalElements: action.payload[2],
    error: undefined,
  };
};

const findAllMunicipalityPageableStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findAllMunicipalityPageableError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const addMunicipality = (state, action) => {
  return {
    ...state,
    loading: false,
    municipalityList: [action.payload].concat(
      state.municipalityList.length === numberOfItemsPerPage
        ? state.municipalityList.filter(
            (req) =>
              req !== state.municipalityList[state.municipalityList.length - 1]
          )
        : state.municipalityList
    ),
    municipality: action.payload,
    error: undefined,
  };
};

const addMunicipalityStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const addMunicipalityError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const updateMunicipality = (state, action) => {
  return {
    ...state,
    loading: false,
    municipalityList: state.municipalityList.map((municipality) =>
      municipality.id === action.payload.id ? action.payload : municipality
    ),
    error: undefined,
  };
};

const updateMunicipalityStart = (state) => {
  return {
    ...state,
    error: undefined,
  };
};
const updateMunicipalityError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_MUNICIPALITY_LIST:
      return findAllMunicipality(state, action);
    case GET_MUNICIPALITY_LIST_START:
      return findAllMunicipalityStart(state, action);
    case GET_MUNICIPALITY_LIST_ERROR:
      return findAllMunicipalityError(state, action);

    case GET_MUNICIPALITY_LIST_BY_PLACE:
      return findAllMunicipalityByPlace(state, action);
    case GET_MUNICIPALITY_LIST_BY_PLACE_START:
      return findAllMunicipalityByPlaceStart(state, action);
    case GET_MUNICIPALITY_LIST_BY_PLACE_ERROR:
      return findAllMunicipalityByPlaceError(state, action);

    case GET_MUNICIPALITY_LIST_PAGEABLE:
    case GET_MUNICIPALITY_FILTER_LIST:
      return findAllMunicipalityPageable(state, action);
    case GET_MUNICIPALITY_LIST_PAGEABLE_START:
    case GET_MUNICIPALITY_FILTER_LIST_START:
      return findAllMunicipalityPageableStart(state, action);
    case GET_MUNICIPALITY_LIST_PAGEABLE_ERROR:
    case GET_MUNICIPALITY_FILTER_LIST_ERROR:
      return findAllMunicipalityPageableError(state, action);

    case ADD_MUNICIPALITY:
      return addMunicipality(state, action);
    case ADD_MUNICIPALITY_START:
      return addMunicipalityStart(state, action);
    case ADD_MUNICIPALITY_ERROR:
      return addMunicipalityError(state, action);

    case UPDATE_MUNICIPALITY:
      return updateMunicipality(state, action);
    case UPDATE_MUNICIPALITY_START:
      return updateMunicipalityStart(state, action);
    case UPDATE_MUNICIPALITY_ERROR:
      return updateMunicipalityError(state, action);

    case CLEAR_MUNICIPALITY_LIST:
      return clearList(state);

    default:
      return state;
  }
}
